export default __webpack_public_path__ + "static/media/i_am_student.257bf3e4.png";